import React from "react";
import Marquee from "./magicui/Marquee";
import { MarqueeDemo } from "./MarqueeDemo";

const Acheivement = () => {
  return (
    <div className="px-16 md-mx:px-6 my-10 font-mono" id="Skills">
      <h1 className="text-4xl sm-mx:text-3xl xs-mx:text-2xl mb-10 font-bold text-center text-white">
       
      </h1>
      {/* Insert Marquee here */}
      <MarqueeDemo />
    </div>
  );
};

export default Acheivement;
